type SlotProps = Record<string, any>

// EXPL: MUI's `slotProps` is a flat record of per-slot entries. Spreading a caller's picker props
// and then setting `slotProps` on the same element replaces that record wholesale, so every option
// the caller passed was silently dropped. Merge per slot instead. One level deep: a caller's entry
// overrides ours key by key rather than replacing the whole slot, which is what lets a caller tweak
// a single option (`{ inputAdornment: { hidden: true } }`) without losing the classes we set.
export function mergeSlotProps(own: SlotProps, caller?: SlotProps): SlotProps {
  if (!caller) {
    return own
  }

  return Object.keys(caller).reduce((merged: SlotProps, slot: string) => {
    const ownSlot = own[slot]
    const callerSlot = caller[slot]

    if (callerSlot === undefined) {
      return merged
    }

    const bothPlainObjects = Boolean(ownSlot)
      && typeof ownSlot === 'object'
      && typeof callerSlot === 'object'

    merged[slot] = bothPlainObjects ? { ...ownSlot, ...callerSlot } : callerSlot
    return merged
  }, { ...own })
}
